import { takeLatest, call, put, select } from 'redux-saga/effects';

import { type ProcessType } from '@frontend/api';

import processesService from 'services/processesService';

import { getGroupId } from 'store/session/selectors';

import { fetchProcesses, types } from './actions';

export default function* root() {
  yield takeLatest(types.FETCH_PROCESSES_REQUEST, watchFetchProcesses);
}

function* watchFetchProcesses() {
  try {
    const groupId: string = yield select(getGroupId);
    const response: ProcessType[] = yield call(
      processesService.processes.listProcesses,
      groupId,
    );
    yield put(fetchProcesses.success({ processes: response }));
  } catch (error) {
    yield put(fetchProcesses.error(error));
  }
}
